import React from 'react'
import { Heading } from 'components/Heading'
import { CallToAction } from 'components/CallToAction'
import GithubSlugger from 'github-slugger'
import { GatsbyImage } from 'gatsby-plugin-image'
import { prepareData } from 'utils/googleData'
import Scroll from 'react-scroll'

export function EventHero(props) {
    const scroll = Scroll.animateScroll

    const scrollToForm = () => {
        scroll.scrollTo(document.getElementById('registration-form').offsetTop, {
            duration: 1500,
            delay: 100,
            smooth: true,
            offset: -50,
        })
    }

    const {
        enable,
        title,
        subtitle,
        video,
        description,
        cta,
        cards,
        direction,
        style,
        gatsbyImage,
        features,
        gatsbyTransformed,
    } = prepareData({ props })
    if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return null
    }
    console.log('props', props)
    const slugger = new GithubSlugger()
    const id = slugger.slug(title)

    return (
        <div direction={direction} className="relative text-center">
            {gatsbyImage && (
                <GatsbyImage
                    image={gatsbyImage}
                    alt="Event Header Image"
                    className="h-auto w-full"
                    imgStyle={{ objectFit: 'cover' }}
                />
            )}
            {title && (
                <div
                    className="absolute top-0 left-0 flex h-full w-full flex-col items-center justify-center"
                    style={{ background: 'rgba(0, 0, 0, 0.5)' }}
                >
                    {title && (
                        <Heading
                            hideCopy
                            id={id}
                            as="h1"
                            className="mt-0 mb-4 text-4xl font-bold leading-none text-white shadow-lg md:text-5xl"
                        >
                            <div dangerouslySetInnerHTML={{ __html: title }} />
                        </Heading>
                    )}
                    {subtitle && (
                        <h2 className="mb-8 !mt-0 text-lg font-semibold leading-relaxed text-white shadow-lg md:text-xl">
                            {subtitle}
                        </h2>
                    )}
                </div>
            )}
            {video && (
                <div className="mt-4 mb-8">
                    {/* Assuming video is a URL to an embeddable content */}
                    <iframe
                        width="100%"
                        height="315"
                        src={video}
                        frameBorder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen
                    ></iframe>
                </div>
            )}
            {cta && (
                <div className="mt-8 flex flex-col items-center space-y-3">
                    <CallToAction onClick={scrollToForm} width={cta.width} type={cta.type}>
                        {cta.label}
                    </CallToAction>
                </div>
            )}
        </div>
    )
}

export default EventHero
